export const buildYouTubeEmbedUrl = ({
    videoId,
    autoplay = false,
    startAt = 0,
    endAt = null,
    mute = false,
    controls = true,
    modestBranding = true,
    loop = false,
    rel = false, // same channel
    privacyMode = true
}) => {
    if (!videoId) {
        throw new Error('YouTube videoId is required');
    }

    const base = privacyMode
        ? 'https://www.youtube-nocookie.com/embed/'
        : 'https://www.youtube.com/embed/';

    const params = new URLSearchParams();

    if (autoplay) params.append('autoplay', '1');
    if (mute) params.append('mute', '1');
    if (!controls) params.append('controls', '0');
    if (modestBranding) params.append('modestbranding', '1');
    if (loop) {
        params.append('loop', '1');
        params.append('playlist', videoId); // loop requires playlist param
    }
    if (!rel) params.append('rel', '0');
    if (startAt > 0) params.append('start', startAt);
    if (endAt) params.append('end', endAt);

    return `${base}${videoId}?${params.toString()}`;
}